import React from "react";
import { Diamond } from "lucide-react";
import { TICKER_ITEMS } from "../lib/services";

export default function Ticker({ className = "" }) {
  const items = [...TICKER_ITEMS, ...TICKER_ITEMS, ...TICKER_ITEMS, ...TICKER_ITEMS];
  return (
    <div
      className={`w-full overflow-hidden border-b border-brand-hair bg-brand-ink text-brand-ivory ${className}`}
    >
      <div className="marquee-track flex whitespace-nowrap py-3">
        {items.map((label, i) => (
          <div key={i} className="flex items-center gap-6 pr-6 font-mono text-[11px] uppercase tracking-[0.22em] text-brand-ivory/85">
            <Diamond className="h-3 w-3 rotate-45 fill-brand text-brand" strokeWidth={0} />
            <span>{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
